import React from 'react';
import { useParams } from 'react-router-dom';
import servicesData from '../data/servicesData';
import ServicePageLayout from '../components/ServicePageLayout';

const ServiceDetail = () => {
  const { slug } = useParams();
  const service = servicesData.find((s) => s.slug === slug);

  if (!service) {
    return (
      <div style={{
        minHeight: '60vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'var(--font-body)',
        color: '#071B3A',
        textAlign: 'center',
        padding: '40px 24px',
      }}>
        <div>
          <h1 style={{ fontFamily: 'var(--font-display)', fontSize: '36px', marginBottom: '12px' }}>
            Service Not Found
          </h1>
          <p style={{ color: 'var(--c-secondary)', fontSize: '17px' }}>
            The service you are looking for does not exist.
          </p>
        </div>
      </div>
    );
  }

  return <ServicePageLayout service={service} />;
};

export default ServiceDetail;
